<template>
	<div
		 :class="[
			'tiles-form-group',
			{'is-disabled': groupheading.isDisabled}
		]"
	>
		<h2 class="common__heading bottom-gap-xs">{{ header }}</h2>
		<h3 class="common__sub-heading bottom-gap-lg">{{ subHeader }}</h3>
		<div class="tiles-form-group__container">
			<div
				class="tiles-form-group__item"
				v-for="(tile, index) in checkboxes"
				:key="index"
				v-show="tile.isShow"
			>
				<img-tile
					:tile="tile"
					@click.native="clickHandler(groupName, index)"
				></img-tile>
			</div>
		</div>
	</div>
</template>

<script>
	import ImgTile from '../formFields/ImgTile.vue';

	export default {
    props: {
      header: {
        type: String
      },
      subHeader: {
        type: String
      },
      groupheading: {
        type: Object,
        required: true
      },
      checkboxes: {
        type: Array,
        required: true
      },
      groupName: {
        type: String,
        required: true
      },
      clickHandler: {
        type: Function,
        required: true
      }
    },
    components: {
      ImgTile
    }
  };
</script>

<style lang="scss">
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";

	$columnsFlexBasis: (
		default : 50%,
		mobile: 33.3333%,
		largeMobile: 25%,
		tablet: 16.66666%
	);

	$bottomPadding: (
		default: 30px,
		largeMobile: 50px
	);

	.tiles-form-group {
    @include attr-bp($bottomPadding, 'padding-bottom');

    position: relative;

    &__container {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-right: -15px;
      margin-bottom: -15px;
    }

    &__item {
      @include attr-bp($columnsFlexBasis, 'flex-basis');
      @include attr-bp($columnsFlexBasis, 'max-width'); // IE fix

      padding-right: 15px;
      margin-bottom: 15px;
      flex-grow: 0;
      flex-shrink: 0;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: $col-neutral--0;
      opacity: 0;
      visibility: hidden;
      transition-property: opacity, visibility;
      transition-duration: $ttime;
      transition-delay: 0ms, $ttime;
    }

    &.is-disabled {
      pointer-events: none;

      &::after {
        visibility: visible;
        opacity: 0.6;
        transition-delay: 0ms, 0ms;
      }
    }
  }
</style>